import {
  dateToFiscalQuarterString,
  dateToFiscalYearString,
} from 'javascripts/util/fiscalFormats';
import React from 'react';

export default class DeprecatedScaleMajorIntervals extends React.Component {
  majorIntervals() {
    switch (this.props.scale.majorInterval) {
      case 'weeks':
        return this.weekInterval();
      case 'months':
        return this.monthInterval();
      case 'quarters':
        return this.quarterInterval();
      case 'years':
        return this.yearInterval();
    }
  }

  wrapInSpans(text, classNames = []) {
    return text.split(' ').map((t, i) => (
      <span key={i} className={`interval-${classNames[i]}`}>
        {t}
      </span>
    ));
  }

  weekInterval() {
    return this.props.scale.majorIntervals().map((date, index) => {
      return (
        <li key={this.key(index)} style={this.intervalStyle(date)}>
          {this.wrapInSpans(date.format('MMM D'), ['secondary', 'primary'])}
        </li>
      );
    });
  }

  monthInterval() {
    return this.props.scale.majorIntervals().map((date, index) => {
      const formattedDate = date.format('MMM YYYY');
      return (
        <li key={this.key(index)} style={this.intervalStyle(date)}>
          {this.wrapInSpans(formattedDate, ['primary', 'secondary'])}
        </li>
      );
    });
  }

  quarterInterval() {
    let prevMonth;
    return this.props.scale.majorIntervals().map((date, index) => {
      let currentMonth = date.format('YYYY-MM');
      // Month stored in scale.options.fiscalMonth in the DB is 1-based, whereas JS dates are 0-based.
      if (
        index === 0 ||
        (date.month() % 3 === (this.props.scale.options.fiscalMonth - 1) % 3 &&
          currentMonth !== prevMonth)
      ) {
        prevMonth = currentMonth;
        const value = dateToFiscalQuarterString(date, {
          fiscalMonth: this.props.scale.options.fiscalMonth,
          format: this.props.scale.options.fiscalYearFormat,
        });

        // Testing for Q1, Q2, Q3, Q4 within the string. Depending on how we want this to work, we may want to
        // mark the "Q1" as primary and the "2023" as secondary for styling purposes, or vice versa.
        const classNames = /^Q/.test(value)
          ? ['primary', 'secondary']
          : ['secondary', 'primary'];
        return (
          <li
            key={this.key(index)}
            style={this.intervalStyle(date)}
            className={date.day()}
          >
            {this.wrapInSpans(value, classNames)}
          </li>
        );
      } else {
        return null;
      }
    });
  }

  yearInterval() {
    return this.props.scale.majorIntervals().map((date, index) => (
      <li key={this.key(index)} style={this.intervalStyle(date)}>
        {dateToFiscalYearString(date, {
          fiscalMonth: this.props.scale.options.fiscalMonth,
          format: this.props.scale.options.fiscalYearFormat,
        })}
      </li>
    ));
  }

  key(index) {
    return `major-intervals-${index}`;
  }

  intervalStyle(date) {
    return { left: this.props.scale.dateToOffset(date) };
  }

  render() {
    return (
      <ul
        className={`major-intervals major-intervals--${this.props.scale.majorInterval}`}
      >
        {this.majorIntervals()}
      </ul>
    );
  }
}
